<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <header>化工标签二维码追溯系统</header>

      <section class="box">
        <div class="stTitle"><a><img src="../../static/images/pesticide/icon_01.png"></a><a>产品信息</a></div>
        <div>
          <ul class="stMain">
            <li><a>产品名称：</a><a v-text="datas.product.name"></a></li>
            <li>
              <a>登记类别：</a>
              <a v-text="typeArray[datas.product.reg_code_type]"></a>
            </li>
            <li><a>登记证号：</a><a v-text="datas.product.reg_code_str"></a></li>
            <li><a>{{datas.business.rootid == '100010085'?'登记证持有人：':'生产经营者：'}}</a><a v-text="datas.product.reg_code_owner"></a></li>
            <li><a>追溯地址：</a><a class="skip" href="/#/PesticideDetails">https://lj.oid.plus</a></li>
          </ul>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Pesticide05',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data () {
    return {
      code:null,
      count:2,
      datas:null,
      Loading:{
        type:1,
        txt:"数据请求中..."
      },
      Music:{
        url:null,
        type:false
      },
      typeArray: ['', 'PD', 'WP', '临时登记', '正式登记']
    }
  },
  created () {
    self = this;

    //判断是演示还是真实码标
    if(this.$route.query.type == "demo"){
      self.GetDemoDatas(this.$route.query.pid,this.$route.query.rid);  //获取演示模板信息
    }else{
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }

    document.title = "农药二维码追溯系统";  //设置页面标题
    document.body.style.backgroundColor = "#FFF";
  },
  updated () {

  },
  methods:{
    GetDemoDatas (pid,rid) {
      axios.get(self.GetServerUrl(1)+"template_product/"+pid+"/"+rid)
      .then(function (response){
        let datas = response.data.meta;
        let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

        if(datas.scan_count){
          datas.scan_count = datas.scan_count;
        }else{
          datas.scan_count = 1;
        }
        datas.scan_first_time = "2017-10-31 12:12";
        datas.scan_first_address = "广东省深圳市";
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }else{
          if(defaultDatas.ref){
            datas.ref = JSON.parse(defaultDatas.ref);
          }
        }
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        if(datas.batch){
          datas.batch = JSON.parse(datas.batch);
          datas.batch.qc = JSON.parse(datas.batch.qc);
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;

        //默认信息
        if(!datas.process){
          datas.process = defaultDatas.process;
        }
        if(!datas.process_demo){
          datas.process_demo = defaultDatas.process_demo;
        }
        if(!datas.dealer){
          datas.dealer = defaultDatas.dealer;
        }
        self.datas = datas;

      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    GetDatas () {
      axios.get(self.GetServerUrl(1)+"query/"+self.code)
      .then(function (response){
        let datas = response.data.meta.product_template;
        datas.scan_count = response.data.meta.scan_count;  //扫码次数
        datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
        datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点

        //双宁产品下架特殊处理
        if([10001001400005,10001010400004,10001010400267,10001010400268,10001010400279,10001010400280,10001010400315,10001010400368].indexOf(datas.product.production_id) !== -1){
          self.Loading.type = 3;
          self.Loading.txt = "产品已下架！";
          return;
        }

        //自定义属性
        if(response.data.meta.activation_a){
          datas.attribute = JSON.parse(response.data.meta.activation_a);
        }
        //焦点图
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        //自定义栏目
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }
        //自定义菜单
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        //产品自定义属性
        if (datas.product.attribute) {
          datas.product.attribute = JSON.parse(datas.product.attribute);
        }
        //企业自定义属性
        if (datas.business.customize_data) {
          datas.business.customize_data = JSON.parse(datas.business.customize_data);
        }
        //批次信息
        if(datas.batch){
          if(datas.batch.qc){
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;
        datas.code = self.code;
        self.datas = datas;

        localStorage.setItem("wwm_pesticideDetail",JSON.stringify(datas));
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    PreviewImgs () {
      self.$viewer.show();
      self.$viewer.update();
    }
  }
}
</script>

<style scoped>
  header{
    width: 100%;
    color: #fff;
    padding: 13px 0;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
    background-color: #317ef3;
  }
  .box{
    padding:0px 10px;
    padding-bottom: 20px;
  }
  .stTitle{
    overflow: hidden;
    margin-top:20px;
  }
  .stTitle a{
    display: block;
    color:#317ef3;
    float: left;
    font-size:17px;
    line-height:40px;
  }
  .stTitle img{
    display: block;
    width:35px;
    margin-right:5px;
  }
  .stMain{
    margin-top:5px;
    background-color: #eaedf1;
    padding:0px 5px;
    overflow:hidden ;
  }
  .stMain li{
    font-size:14px;
    padding:0px 5px;
    padding-bottom:10px;
    line-height:23px;
    overflow: hidden;
  }
  .stMain li a{
    display: block;
    float: left;
  }
  .stMain li:first-child{
    padding-top:10px;
  }
  .stMain li a:first-child{
    color:#444;
  }
  .stCopyright{
    font-size:12px;
    text-align: center;
    padding:20px 0;
  }
  .stCopyright a{
    color:#000;
    text-decoration: none;
  }

  .stMainTwo{
    margin-top:5px;
    background-color: #eaedf1;
    border:1px solid #d8e2f0;
  }
  .stMainTwo li{
    overflow: hidden;
    color:#444;
    font-size:13px;
    border-bottom:1px solid #d8e2f0;
  }
  .stMainTwo li:last-child{
    border-bottom:0;
  }
  .stMainTwo li:first-child{
    color:#000;
    font-size:14px;
  }
  .stMainTwo li:first-child a{
    padding:12px 0px;
  }
  .stMainTwo li a{
    float: left;
    width:49.5%;
    line-height:24px;
    padding:10px 0px;
    display: block;
    text-align: center;
    border-right: 1px solid #d8e2f0;
  }
  .stMainTwo li a:last-child{
    border-right: 0px;
  }
  .stPimg{
    padding:0px 0;
    margin:8px 5px;
  }
  .stPimg img{
    display: block;
    width:100%;
    margin:0px auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/Pesticide05.vue